module.exports = __webpack_public_path__ + "img/facilities-icon-5.feb76f29.svg";